module.exports = __webpack_public_path__ + "static/media/bricked.a36a1323.jpg";